import { DEFAULT_GROUP, gql } from "@edreamsodigeo/frontend-api-client";

import { USER_FRAGMENT } from "../../fragments";
import { AUTH_CHANGE_GROUP } from "../../groups";

export const GET_USER = gql`
  ${USER_FRAGMENT}
  query GetUser @update_groups(groups: "${DEFAULT_GROUP},${AUTH_CHANGE_GROUP}") {
    getUser {
      ...UserParts
    }
  }
`;

export default GET_USER;
